const ftCanvas = document.createElement('canvas');

interface ShaderFeature {
  isSupported: () => boolean;
}

interface FeaturesResult {
  SHADER_INTERPOLATION: ShaderFeature;
  SHADER_SPLATS: ShaderFeature;
  SHADER_EDL: ShaderFeature;
  precision: string;
}

export const Features: FeaturesResult | null = (function (): FeaturesResult | null {
  const gl = ftCanvas.getContext('webgl2') ?? ftCanvas.getContext('webgl');
  if (gl === null) {
    return null;
  }

  // We need a WebGL context (not just RenderingContext) for shader precision queries.
  // Both webgl2 and webgl return a context with these methods.
  const glCtx = gl as WebGLRenderingContext;

  // -- code taken from THREE.WebGLRenderer --
  const _vertexShaderPrecisionHighpFloat = glCtx.getShaderPrecisionFormat(glCtx.VERTEX_SHADER, glCtx.HIGH_FLOAT);
  const _vertexShaderPrecisionMediumpFloat = glCtx.getShaderPrecisionFormat(glCtx.VERTEX_SHADER, glCtx.MEDIUM_FLOAT);

  const _fragmentShaderPrecisionHighpFloat = glCtx.getShaderPrecisionFormat(glCtx.FRAGMENT_SHADER, glCtx.HIGH_FLOAT);
  const _fragmentShaderPrecisionMediumpFloat = glCtx.getShaderPrecisionFormat(glCtx.FRAGMENT_SHADER, glCtx.MEDIUM_FLOAT);

  if (!_vertexShaderPrecisionHighpFloat || !_vertexShaderPrecisionMediumpFloat || !_fragmentShaderPrecisionHighpFloat || !_fragmentShaderPrecisionMediumpFloat) {
    return null;
  }

  const highpAvailable = _vertexShaderPrecisionHighpFloat.precision > 0 && _fragmentShaderPrecisionHighpFloat.precision > 0;
  const mediumpAvailable = _vertexShaderPrecisionMediumpFloat.precision > 0 && _fragmentShaderPrecisionMediumpFloat.precision > 0;
  // -----------------------------------------

  let precision: string;
  if (highpAvailable) {
    precision = 'highp';
  } else if (mediumpAvailable) {
    precision = 'mediump';
  } else {
    precision = 'lowp';
  }

  return {
    SHADER_INTERPOLATION: {
      isSupported: function () {
        let supported = true;

        supported = supported && !!glCtx.getExtension('EXT_frag_depth');
        supported = supported && glCtx.getParameter(glCtx.MAX_VARYING_VECTORS) >= 8;

        return supported;
      },
    },
    SHADER_SPLATS: {
      isSupported: function () {
        let supported = true;

        supported = supported && !!glCtx.getExtension('EXT_frag_depth');
        supported = supported && !!glCtx.getExtension('OES_texture_float');
        supported = supported && glCtx.getParameter(glCtx.MAX_VARYING_VECTORS) >= 8;

        return supported;
      },
    },
    SHADER_EDL: {
      isSupported: function () {
        let supported = true;

        supported = supported && !!glCtx.getExtension('EXT_frag_depth');
        supported = supported && !!glCtx.getExtension('OES_texture_float');
        supported = supported && glCtx.getParameter(glCtx.MAX_VARYING_VECTORS) >= 8;

        supported = supported || gl instanceof WebGL2RenderingContext;

        return supported;
      },
    },
    precision: precision,
  };
})();
